// extracted by mini-css-extract-plugin
export default {"points":"InformationStep_points__ns6y8","point":"InformationStep_point__RHht0","active":"InformationStep_active__hivja","step":"InformationStep_step__hiJsR"};